export default __webpack_public_path__ + "static/media/laptop.ce6ce039.svg";